import { render } from "./WrapWithOverlay.vue?vue&type=template&id=1ea4c049"
import script from "./WrapWithOverlay.vue?vue&type=script&lang=js"
export * from "./WrapWithOverlay.vue?vue&type=script&lang=js"

import "./WrapWithOverlay.vue?vue&type=style&index=0&id=1ea4c049&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__